/**
 * Session cookie
 * @type {Object}
 */
const sessionstore = {
  s: window.sessionStorage,
  type: 'sessionStorage',
  set: function (key, val) {
    this.s.setItem(key, JSON.stringify(val));

    return val;
  },
  get: function (key) {
    const value = this.s.getItem(key);

    if (typeof value != 'string') {
      return undefined;
    }

    try {
      return JSON.parse(value);
    } catch (e) {
      return value || undefined;
    }
  },
  remove: function (key) {
    this.s.removeItem(key);
  },
  removeAll: function () {
    this.s.clear()
  },
  getAll: function () {
    let ret = {};

    for (var i = 0; i < this.s.length; i++) {
      let key = this.s.key(i);

      ret[key] = this.get(key);
    }

    return ret;
  }
};

export default sessionstore;
